
/**
 * 링크 유형 (외부 링크 또는 프로젝트 링크)
 */
export type GetExploreContent200PageAllOfThreeContentItemContentOneOfThreesevenMediaLinksItemLinkType = typeof GetExploreContent200PageAllOfThreeContentItemContentOneOfThreesevenMediaLinksItemLinkType[keyof typeof GetExploreContent200PageAllOfThreeContentItemContentOneOfThreesevenMediaLinksItemLinkType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetExploreContent200PageAllOfThreeContentItemContentOneOfThreesevenMediaLinksItemLinkType = {
  EXTERNAL: 'EXTERNAL',
  PROJECT: 'PROJECT',
} as const;
